import {
  EMPTY_HOTEL_RESULTS_FILTERS,
  type HotelResultsFilterValue,
} from '@voll-intelligence/intelligence-ui-kit';

import {
  directiveRatingBands,
  type HotelPlannerDirectives,
} from '@voll-intelligence/genui-contract';

/** As faixas do painel que a diretiva acende — a MESMA linha que a doca usa
 *  para cortar (`directiveRatingFloor`, camada pura), para painel e doca
 *  aplicarem um corte só (cena = card). Piso fora do vocabulário do painel
 *  (`[5]`, `[4.2]`) encosta na faixa mais próxima LÁ, não aqui. */
function panelRatingBands(
  filter: HotelPlannerDirectives['filter'],
): HotelResultsFilterValue['ratingBands'] {
  return directiveRatingBands(filter?.ratingFloors);
}

/** Os três booleanos de tarifa/política do filtro de diretiva. Ausentes (não
 *  `false` explícito) quando a diretiva não pede o corte — quem completa o
 *  default é o `...EMPTY_HOTEL_RESULTS_FILTERS` abaixo. */
function directiveStayFilters(
  filter: HotelPlannerDirectives['filter'],
): Partial<Pick<HotelResultsFilterValue, 'policyOnly' | 'breakfastOnly' | 'refundableOnly'>> {
  return {
    ...(filter?.policyOnly ? { policyOnly: true } : {}),
    ...(filter?.breakfastOnly ? { breakfastOnly: true } : {}),
    ...(filter?.refundableOnly ? { refundableOnly: true } : {}),
  };
}

/** Preço/distância/comodidade do filtro de diretiva — os eixos que sobram
 *  depois de `directiveStayFilters`/`directiveRatingBands` (teto de
 *  complexidade do lint). */
function directivePriceAndMoreFilters(
  filter: HotelPlannerDirectives['filter'],
): Partial<
  Pick<
    HotelResultsFilterValue,
    'minimumNightlyPrice' | 'maximumNightlyPrice' | 'maximumDistance' | 'amenityIds'
  >
> {
  return {
    ...(filter?.minNightlyPrice === undefined
      ? {}
      : { minimumNightlyPrice: filter.minNightlyPrice }),
    ...(filter?.maxNightlyPrice === undefined
      ? {}
      : { maximumNightlyPrice: filter.maxNightlyPrice }),
    ...(filter?.maxDistanceKm === undefined ? {} : { maximumDistance: filter.maxDistanceKm }),
    ...(filter?.amenityIds?.length ? { amenityIds: filter.amenityIds } : {}),
  };
}

/**
 * O filtro de diretiva no vocabulário do PAINEL — a tradução que o painel usa
 * para herdar as diretivas do card (`directivesToPanelQuery`) e que o AGENTE
 * usa para pedir ao modal-session os mesmos cortes que o painel pede
 * (`toHotelResultsCuts`, Onda 1 spec 2026-09-18 §3.3). Módulo PURO, sem React:
 * o agents importa daqui.
 */
export function directiveFiltersValue(
  filter: HotelPlannerDirectives['filter'],
): HotelResultsFilterValue {
  const ratingBands = panelRatingBands(filter);
  return {
    ...EMPTY_HOTEL_RESULTS_FILTERS,
    ...directiveStayFilters(filter),
    ...directivePriceAndMoreFilters(filter),
    ...(ratingBands ? { ratingBands } : {}),
  };
}
